import React from 'react';
import { Button } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';
import { useHistory, useLocation } from 'react-router-dom';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { RoleService } from 'Services';
import PageHeaderTitle from 'Components/PageHeaderTitle';
import AddListEntry from '../single-list-actions/AddListEntry';
import ListActionButton from '../ListActionButton/ListActionButton';

import styles from './Header.css';

type Props = {
    title: string;
    listType: SingleListType;
    listId: number;
    merchantSpecific: boolean;
    customListType?: string;
    isMissingConfigCustomList: boolean;
};

const Header = ({ title, listType, listId, merchantSpecific, customListType, isMissingConfigCustomList }: Props) => {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();

    const goToViewRemovedListEntriesPage = () => {
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.click,
            payload: {
                clickIdentifier: 'Lists - View List Entry History',
                text: 'View List Entry History'
            }
        });
        history.push(`${location.pathname}/removed-list-entries`);
    };

    return (
        <div className={styles.container}>
            <div className={styles.leftItem}>
                <PageHeaderTitle title={title} dataTestId='list-page-title' />
                {RoleService.hasViewRemovedListEntriesAccess && (
                    <div className={styles.leftItem}>
                        <hr className={styles.separator} />
                        <Button
                            dataTestId='view-removed-entries-button'
                            iconName='expand'
                            variant='tertiary'
                            className={styles.bulkButton}
                            onClick={handleOnClickEvent(goToViewRemovedListEntriesPage)}
                            onKeyDown={handleKeyEvent(goToViewRemovedListEntriesPage)}
                        >
                            {t('View Removed Entries')}
                        </Button>
                    </div>
                )}
            </div>

            {RoleService.hasListAccess && (
                <>
                    <div className={styles.rightItem}>
                        <ListActionButton listId={listId} isMissingConfigCustomList={isMissingConfigCustomList} />

                        <hr className={styles.separator} />
                        <AddListEntry
                            listName={title}
                            listId={listId}
                            listType={listType}
                            merchantSpecific={merchantSpecific}
                            customListType={customListType}
                            isMissingConfigCustomList={isMissingConfigCustomList}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default Header;
